import "../../Styles/ClientPayment.css";

function ClientPayment({
  btnLoading,
  onContinue,
  isSelf,
  planType = "individual",
}) {
  const isAgentPlan = planType === "agent";
  const features = isAgentPlan
    ? [
        {
          title: "✥ Client Management",
          items: [
            "End-to-end client management tools",
            "Organize client profiles and details",
          ],
        },
        {
          title: "✥ Matchmaking Support",
          items: [
            "AI-assisted matchmaking support",
            "Verified profile access",
          ],
        },
        {
          title: "✥ Match Tracking",
          items: [
            "Match forwarding and tracking",
            "Faster workflow and organization",
          ],
        },
        {
          title: "✥ Grow Your Network",
          items: [
            "Official agent listing on WedLuk",
            "Grow your client network digitally",
          ],
        },
      ]
    : [
        {
          title: "✥ Smart Matchmaking",
          items: [
            "AI-powered compatible matches",
            "Verified profiles",
            "Mutual connection insights",
          ],
        },
        {
          title: "✥ Collaborative Matchmaking",
          items: [
            "Create/manage multiple profiles",
            "Invite family members",
            "Collaborate on finding matches together",
          ],
        },
        {
          title: "✥ Privacy & Control",
          items: [
            "Privacy-first profile visibility",
            "Blurred photos & selective access",
            "Full control over interactions",
          ],
        },
        {
          title: "✥ Agent-Assisted Matchmaking",
          items: [
            "Work with matrimony agents digitally with WedLuk's collaboration tools.",
            "Upgrade to agent-assisted matchmaking anytime",
          ],
        },
      ];

  return (
    <div className="client-payment-main-wrapper">
      <div className="client-payment-card-wrapper">
        <div className="client-payment-inside-wrapper">
          {/* TOP SECTION */}
          <div className="client-payment-top-section">
            <h2>{isAgentPlan ? "Partner Suite" : "Individual Plan"}</h2>

            <p>
              {isAgentPlan
                ? "Complete your membership to access the full Matchmaking Management Suite."
                : "Complete your membership to access all WedLuk features."}
            </p>

            <div className="client-payment-top-line"></div>
          </div>

          {/* PLAN CARD */}
          <div className="client-payment-plan-card">
            <div className="client-payment-plan-top">
              <div className="client-payment-plan-left">
                <div className="client-payment-diamond-icon pt-2">
                  {" "}
                  <img
                    src={require("../../assests/images/payment_icon.png")}
                    alt=""
                    className="success-icon-img"
                  />
                </div>

                <div>
                  <h4>
                    {isAgentPlan ? "Partner Suite Membership" : "Annual Membership"}
                  </h4>

                  <h3>
                    {" "}
                    ₹ 0/year{" "}
                    {isSelf ? (
                      <span>
                        {" "}
                        <s>₹ 699/year</s>{" "}
                      </span>
                    ) : (
                      <span>Free</span>
                    )}{" "}
                  </h3>
                </div>
              </div>
            </div>

            <div className="client-payment-plan-bottom">
              <div className="client-payment-coupon">
                <span>Coupon applied:</span>

                <div>EARLY-MEMBER ✕</div>
              </div>

              <button
                type="button"
                className="client-payment-start-btn"
                onClick={onContinue}
                disabled={btnLoading || !onContinue}
              >
                {btnLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : (
                  <>
                    Start Plan <span>›</span>
                  </>
                )}
              </button>
            </div>
          </div>

          {/* FEATURES */}
          <div className="client-payment-feature-grid">
            {features.map((feature) => (
              <div className="client-payment-feature-card" key={feature.title}>
                <h3>{feature.title}</h3>
                <ul>
                  {feature.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientPayment;
